import script from "./MergedComparisonChart.vue?vue&type=script&setup=true&lang=js"
export * from "./MergedComparisonChart.vue?vue&type=script&setup=true&lang=js"

import "./MergedComparisonChart.vue?vue&type=style&index=0&id=61f38814&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61f38814"]])

export default __exports__